import {CommonService} from '../services/common.service';
import {Component} from '@angular/core';
import {CookieService} from 'ngx-cookie-service';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {LoadingService} from '../services/loading.service';
import {LoginService} from '../services/login.service';
import {MatDialog} from '@angular/material';
import {Router} from '@angular/router';
import {TwoStepDialogComponent} from './two-step-dialog/two-step-dialog.component';

@Component({
  styleUrls: ['./login.component.scss'],
  templateUrl: './login.component.html'
})
export class LoginComponent {
  public errorLoginNotFound: boolean;
  public errorLoginUnauthorized: boolean;
  public userForm: FormGroup;
  public isLoading: boolean;

  constructor(public commonService: CommonService,
              private cookieService: CookieService,
              private loadingService: LoadingService,
              private loginService: LoginService,
              private matDialog: MatDialog,
              private router: Router) {
    this.errorLoginNotFound = false;
    this.errorLoginUnauthorized = false;
    this.isLoading = false;

    this.userForm = new FormGroup({
      username: new FormControl('', Validators.required),
      password: new FormControl('', Validators.required)
    });

    this.loadingService.hide();
  }

  public isFormValid(): boolean {
    return !this.userForm.valid;
  }

  public keyDownFunction(event) {
    if (event.keyCode === 13) {
      this.loginUser();
    }
  }


  public loginUser(): void {
    this.isLoading = true;

    this.errorLoginUnauthorized = false;
    this.errorLoginNotFound = false;

    this.loginService.login(this.userForm.value).then((response) => {
      if (response.status === 200) {
        // this.cookieService.set('Token', response.body);

        // this.router.navigate(['/home']);
        this.showStep(response.body.user.id);
      }
      if (response.status === 404) {
        this.isLoading = false;

        this.errorLoginNotFound = true;
      }

      if (response.status === 401) {
        this.isLoading = false;

        this.errorLoginUnauthorized = true;
      }
    }).catch((status) => {
      this.isLoading = false;

      this.errorLoginNotFound = true;
    });
  }

  showStep(id: string) {
    const authStepDialog = this.matDialog.open(TwoStepDialogComponent, {
      width: '550px',
      height: '400px',
      data: {
        userId: id
      }
    });

    authStepDialog.afterClosed().subscribe((authMessage) => {
      this.isLoading = false;
      if (authMessage) {
        this.cookieService.set('Token', authMessage);
        this.router.navigate(['home']);
      } else {
      }
    });
  }
}
